import { Alert } from 'antd';

import { Modal } from '../../../components/index';
import { ReleaseDockingModal } from '../../../pages/private/stayment/releaseDockingModal';
import { usePatchDockingMutation } from '../../../services/dockingApi';
import {
  Docking as DockingType,
  Stopover as StopoverType,
} from '../../../types';

type ReleaseDockingBeforeSaveModalProps = {
  visible: boolean;
  setIsVisible: (value: boolean) => void;
  stopover?: StopoverType;
  docking?: DockingType;
  onReleased: (releasedWithPending?: boolean) => void;
};

export function ReleaseDockingBeforeSaveModal(
  props: ReleaseDockingBeforeSaveModalProps
) {
  const { visible, setIsVisible, stopover, docking, onReleased } = props;

  const [patchDocking, { isLoading: isLoadingPatchDocking }] =
    usePatchDockingMutation();

  async function updateDocking(
    update: any,
    callback: (releasedWithPending?: boolean) => void,
    releasedWithPending?: boolean
  ) {
    // notInvalidateTags evita o refetch da escala antes do salvamento em cadeia,
    // o que descartaria os dados preenchidos no formulário
    const updatedDocking = await patchDocking({
      ...update,
      notInvalidateTags: true,
    });
    if ('data' in updatedDocking) {
      callback(releasedWithPending);
    }
    return updatedDocking;
  }

  return (
    <Modal
      visible={visible}
      title="Liberar atracação"
      className="TOSPrimaryModal"
      onCancel={() => setIsVisible(false)}
      width={624}
      footer={null}
      destroyOnClose
    >
      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: '16px' }}
        message="Esta atracação ainda não foi liberada. Deseja realizar a liberação agora para concluir o salvamento?"
        description="Os dados preenchidos no formulário serão salvos automaticamente após a liberação."
      />
      <ReleaseDockingModal
        setIsVisible={setIsVisible}
        onRelease={onReleased}
        stopover={stopover}
        currentDocking={docking}
        updateDocking={updateDocking}
        isLoadingUpdateDocking={isLoadingPatchDocking}
        readOnly={!docking?.pilot_expected_on_board}
      />
    </Modal>
  );
}
